<template>
  <div class="main-content">
    <section class="section">
      <PageHeaderNoAction>
      <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="gocreate()">
              <i class="far fa-plus-square mr-2"></i>{{$helper.getWord('Create User')}}
            </button>
          </div>
          
        
        </template>
        </PageHeaderNoAction>
      <div class="section-body">
        <div class="card">
          <div class="card-header">{{$helper.getWord('All User')}}</div>
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">{{$helper.getWord('Username')}}</th>
                  <th scope="col">{{$helper.getWord('Full Name')}}</th>
                  <th scope="col">{{$helper.getWord('email')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in userlist">
                  <th scope="row">{{index+1}}</th>
                  <td>{{user.username}}</td>
                  <td>{{user.full_name}}</td>
                  <td>{{user.email_address}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api";
import config from "@/config";
import helper from "@/vueHelper";

export default {
  title: "User",
  access_code: "G_USER1",
  hidden: false,
  data() {
    return {
        userlist:""
    };
  },
  mounted(){
      api.request(
          this,
          "post",
          "/system/getUser",
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
            Parameters: {

            }
          },

          function(r) {
            this.userlist=r.data.Alluser;
          });
  },
  methods:{
      gocreate(){
          this.$router.push("/SystemMaintenance/CreateUser/");
      }
  }
}
</script>

<style>
.section-body {
  padding-top: 100px;
}
</style>